import React, { Component } from 'react';
import { isApp, appVersion } from '../../helpers/nativeApp'
import './Loading.css'

export default class Loading extends Component {
  render() {
    // Phone app: carry on from the opening screen (logo on brand purple,
    // with the version) while the player loads
    const app = isApp()
    const version = app ? appVersion() : ''
    return (
      <div className={ app ? 'loading_container loading_container--app' : 'loading_container' }>
        { app && (
          <img className="loading_logo" src="/assets/images/brand/gymradio-logo-on-purple.png" alt="GymRadio.com" />
        ) }
        <div className="loading-wave">
          <div className="loading-rect loading-rect1"></div>
          <div className="loading-rect loading-rect2"></div>
          <div className="loading-rect loading-rect3"></div>
          <div className="loading-rect loading-rect4"></div>
          <div className="loading-rect loading-rect5"></div>
        </div>
        { version && <div className="loading_version">Version { version }</div> }
      </div>
    )
  }
}
